import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { SeatSetting } from '@core/objects/seat';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { SettingsUserSeatStatus } from '@app/store/state/settings/users/users.state';

@Component({
    selector: 'settings-users-info-user-seat',
    templateUrl: './info-user-seat.component.html',
    styleUrls: ['./info-user-seat.component.scss']
})
export class SettingsUsersInfoUserSeatComponent implements OnInit{

	protected readonly INVITATION_EXPIRE_SECONDS = 432000; // 5 days in seconds

	@Input() seatSetting:SeatSetting;
	@Input() menu:Array<ThreeDotsMenuItem> = [];
	@Output() onAction = new EventEmitter<string>();

	@Input() dataDisabled: string = null;

	public seatStatus: string;
	public isExpired: boolean = false;

	public disabledAction: boolean = false;

	constructor(){}

	ngOnInit(){
		if (this.seatSetting.status == SettingsUserSeatStatus.USER_SEAT_ASSIGNED){
			this.seatStatus = "user";
		}
		if (this.seatSetting.status == SettingsUserSeatStatus.USER_SEAT_PENDING){
			this.seatStatus = "invitation";
			if(this.seatSetting.date_created){
				// Convert date_created to a Date object
				const createdDate = new Date(this.seatSetting.date_created);
				const createdTime = createdDate.getTime(); // milliseconds since epoch

				// Calculate expiration time in milliseconds
				const expireTime = createdTime + this.INVITATION_EXPIRE_SECONDS * 1000;

				// Get the current time in milliseconds
				const currentTime = Date.now(); // Current time in UTC

				// Check if expired
				this.isExpired = currentTime > expireTime;
			}
		}
	}

	onMenuSelect(key: string) {
		this.onAction.emit(key);
}
}
